import takeRequest from '~/store/takeRequest';
import { getIN100Process } from './actions';

export function* in100Saga() {
  yield takeRequest(getIN100Process);
}
